import { defineStore } from 'pinia';
import { fetchModule } from '/@/app/services/modules';
import { fetchUserModules } from '/@/app/services/modules';
import { isEmpty } from 'lodash';
import { ModuleListItem, IModule } from '/@/app/types/interfaces';

export const useModulesStore = defineStore({
  id: 'modules',
  state: () => ({
    module: null as IModule | null,
    modules: [] as ModuleListItem[],
    hasMore: true,
    loading: false,
    meta: {
      current_page: 1,
      per_page: 50,
      total_items: 50,
      total_pages: 1,
      next_page: 2,
      prev_page: null,
      has_more: true,
    },
  }),
  getters: {
    currentModule: state => state.module,
    flattenedCourses: state => state.modules,
  },
  actions: {
    async fetchModuleData(moduleId: string) {
      this.loading = true;
      const { onSuccess, onError } = fetchModule(moduleId);

      onSuccess(({ data }) => {
        // Store only the module data
        this.module = data;
        this.loading = false;
      });

      onError(error => {
        console.error('Error fetching module data:', error);
        this.loading = false;
      });
    },

    clearModuleData() {
      this.module = null;
    },

    // Clear the modules list and reset pagination metadata
    clearModules() {
      this.modules = [];
      this.meta = {
        current_page: 1,
        per_page: 50,
        total_items: 0,
        total_pages: 1,
        next_page: 1,
        prev_page: null,
        has_more: false,
      };
    },

    // Load courses with pagination
    async loadUserModules(page: number = 1) {
      try {
        this.loading = true;
        const { onSuccess, onError } = fetchUserModules(page);

        onSuccess(({ data, meta }) => {
          this.meta = meta;
          const filteredData = data.filter(module => !isEmpty(module.course));

          // Add to existing courses array (not replace)
          this.modules = [...this.modules, ...filteredData];
          this.loading = false;
        });

        onError(error => {
          console.error('Error loading courses:', error);
          this.loading = false;
        });
      } catch (error) {
        console.error('Error loading courses:', error);
      }
    },

    // Load next page for infinite scroll
    async loadMoreModules(userId: string) {
      if (this.meta.next_page === null || !this.meta.has_more) {
        return;
      }
      await this.loadUserModules(this.meta.next_page);
    },
  },
});
